import React from 'react';
import Social from './Social';
import './css/About.css';

function About() {
    return (
      <div id="about" className = "text-center">
        <h1>Anthony Marcellino</h1>
        <p>I code stuff</p>
        <div id="socials" className="d-flex justify-content-center mt-3">
          <Social social="LinkedIn" url="https://www.linkedin.com/in/anthony-marcellino-4a110212a/" icon="bi-linkedin" color="#0072B1" />
          <Social social="GitHub" url="https://github.com/TheAnt03/" icon="bi-github" color="#171515" />
        </div>
      </div>
    );
}

export default About;